/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ExchangeRequestBody,
  ExchangeRequestBody$Outbound,
  ExchangeRequestBody$outboundSchema,
} from "../components/exchangerequestbody.js";

export type TokenExchangeSecurity = {
  apikeyHeaderGramKey?: string | undefined;
};

export type TokenExchangeRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  exchangeRequestBody: ExchangeRequestBody;
};

/** @internal */
export type TokenExchangeSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const TokenExchangeSecurity$outboundSchema: z.ZodMiniType<
  TokenExchangeSecurity$Outbound,
  TokenExchangeSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function tokenExchangeSecurityToJSON(
  tokenExchangeSecurity: TokenExchangeSecurity,
): string {
  return JSON.stringify(
    TokenExchangeSecurity$outboundSchema.parse(tokenExchangeSecurity),
  );
}

/** @internal */
export type TokenExchangeRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  ExchangeRequestBody: ExchangeRequestBody$Outbound;
};

/** @internal */
export const TokenExchangeRequest$outboundSchema: z.ZodMiniType<
  TokenExchangeRequest$Outbound,
  TokenExchangeRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    exchangeRequestBody: ExchangeRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      exchangeRequestBody: "ExchangeRequestBody",
    });
  }),
);

export function tokenExchangeRequestToJSON(
  tokenExchangeRequest: TokenExchangeRequest,
): string {
  return JSON.stringify(
    TokenExchangeRequest$outboundSchema.parse(tokenExchangeRequest),
  );
}
